
import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
// api
import { ResourceCategory } from "@/types/api/resource";
@Component
export default class Header extends Vue {}
